import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { DevicesDataState, AuthDataState, Device } from 'interfaces/auth'
import { SET_DEVICES, DELETE_DEVICE } from 'actions/authActions'
import { removeByKeyFromCollection } from 'helpers/normalizeHelpers'

const devicesReducer: Reducer<DevicesDataState | null> = (state = null, action) => {
  switch (action.type) {
    case SET_DEVICES:
      return action.payload

    case DELETE_DEVICE:
      return state
        ? removeByKeyFromCollection<Device, 'id'>(state, action.payload)
        : null

    default:
      return state
  }
}

export default combineReducers<AuthDataState>({
  devices: devicesReducer,
})
